import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

/**
 * Omitted from published OpenAPI until BE documents change-categories endpoints (TROC-299).
 * Symbol naming follows Orval's V1 convention so the regenerated client can replace this file.
 */
export const getApiUserManagementV1SettingsChangeCategories = (options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<unknown>(
    { url: '/api/user-management/v1/settings/change-categories', method: 'GET', signal },
    options
  );
};

export const getApiUserManagementV1SettingsChangeCategoriesActive = (options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<unknown>(
    { url: '/api/user-management/v1/settings/change-categories/active', method: 'GET', signal },
    options
  );
};

export const putApiUserManagementV1SettingsChangeCategories = (
  updateChangeCategoriesInput: unknown,
  options?: RequestOptions,
  signal?: AbortSignal
) => {
  return axiosInstance<unknown>(
    {
      url: '/api/user-management/v1/settings/change-categories',
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateChangeCategoriesInput,
      signal
    },
    options
  );
};
